export const publicUrl = (url: string) => process.env.PUBLIC_URL + url;
